// extracted by mini-css-extract-plugin
export default {"af_tool":"CalculationId_af_tool__ei0tq styles_bodyClass__sk1pZ","formWrapper":"CalculationId_formWrapper__vrq3U"};